import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SecurityService } from './securityService';
import { Observable } from 'rxjs';

@Injectable()
export class HttpService {
    constructor(public http: HttpClient, private securityService: SecurityService) {}

    public get<T>(url: string, responseType?: 'json' | 'arraybuffer'): Observable<T> {
        if (responseType) {
            return this.http.request('GET', url, {
                headers: this.getDefaultHttpHeaders(),
                responseType
            });
        }

        return this.http.get<T>(url, { headers: this.getDefaultHttpHeaders() });
    }

    public post<T, K>(url: string, body: T): Observable<K> {
        return this.http.post<K>(url, body, {headers: this.getDefaultHttpHeaders() });
    }

    public put<T, K>(url: string, body: T): Observable<K> {
        return this.http.put<K>(url, body, { headers: this.getDefaultHttpHeaders() });
    }

    public delete<T>(url: string): Observable<T> {
        return this.http.delete<T>(url, { headers: this.getDefaultHttpHeaders() });
    }

    private getDefaultHttpHeaders(): HttpHeaders {
        const defaultHeaders: { [key: string]: any } = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };

        return new HttpHeaders(defaultHeaders);
    }
}
